import { useHistory } from 'react-router-dom'
import { useNotification } from 'src/contexts/notification.context'
import { BackLink } from 'src/components/common'
import { createClassroomRequest } from 'src/services/api.service'
import { routes } from 'src/navigation/routes'
import ClassroomForm from './form'

export const NewClassroom = () => {
  const history = useHistory()
  const { wrapCallback } = useNotification()

  const initialValues = {
    color: '1',
    name: '',
    description: '',
    grade_id: null,
    subject_id: null,
    active: 1,
  }

  const onSubmit = (values) => {
    wrapCallback(async () => {
      await createClassroomRequest(values)
      history.replace(routes.classrooms.index)
    })
  }

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to={routes.classrooms.index} />
        <h2 className="sectionHb-title">New Classroom</h2>
      </div>

      <div className="sectionHb-block purchaseHb">
        <div className="sectionHb-block__wrap">
          <ClassroomForm initialValues={initialValues} onSubmit={onSubmit} />
        </div>
      </div>
    </>
  )
}
